import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Dashboard from './pages/user/Dashboard';
import Logout from './pages/user/Logout';
import PrivateRoute from './pages/user/PrivateRoute';
import Api from './Api';
import Profiles from './pages/main/Auth/Profiles';
import Data from './pages/user/Data';
import GrafikJurnal from './pages/user/GrafikJurnal';
import Login from './pages/Login';
import LoginCallback from './pages/LoginCallback';
import DataSaya from './pages/user/DataSaya';
import Home from './pages/Home';
import GrafikJurnalAuth from './pages/user/GrafikJurnalAuth';
import Repository from './pages/Repository';
import Cari from './pages/Cari';
import DashboardReview from './pages/user/DashboardReview';
import ProfilP from './pages/user/public/Profil';
import PublikasiP from './pages/user/public/PublikasiP';
import PublikasiAll from './pages/user/public/PublikasiAll';
import ReviewRoute from './pages/user/ReviewRoute';

function App() {
  return (
    <>
      <Api>
        <Router>
          <Profiles>
            <Routes>
              <Route element={<PrivateRoute />}>
                <Route path='/dashboard' element={<Dashboard />} />
                <Route path='/data' element={<Data />} />
                <Route path='/grafik-jurnal' element={<GrafikJurnal />} />
                <Route path='/data-saya' element={<DataSaya />} />
                <Route path='/data-jurnal' element={<GrafikJurnalAuth />} />
              </Route>
              <Route element={<ReviewRoute />}>
                <Route path='/reviewer/dashboard' element={<DashboardReview />} />
              </Route>
            </Routes>
          </Profiles>
          <Routes>
            <Route exact path='/public/profil/:id' element={<ProfilP />} />
            <Route exact path='/public/profil/:id/:state' element={<PublikasiP />} />
            <Route exact path='/public/publikasi/:state' element={<PublikasiAll />} />
            <Route path='/cari' element={<Cari />} />
            <Route path='/repository' element={<Repository />} />
            <Route path='/login' element={<Login />} />
            <Route path='/login/keycloak/callback' element={<LoginCallback />} />
            <Route path='/logout' element={<Logout />} />
            <Route exact path='/' element={<Home />} />
          </Routes>
        </Router>
      </Api>
    </>

  );
}

export default App;
